import { useState, useEffect, useContext } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom';
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";

import { MdOutlineArrowLeft, MdOutlineLocalPrintshop, MdOutlineFactCheck, MdOutlineSend, MdOutlineTextIncrease, MdOutlineTextDecrease, MdOutlineFileDownload, MdCheckBoxOutlineBlank } from "react-icons/md";
import { AiOutlineAppstoreAdd } from "react-icons/ai";
import { BsPencil, BsThreeDotsVertical } from "react-icons/bs";
import { PiStudent, PiPencil, PiBuildingsLight } from "react-icons/pi";
import { LuSheet } from "react-icons/lu";

import './css/view.css'

import { AppContext } from "../../Context";
import { Loader, GET, ClassToName, permissions } from "../../inc/Fetch"; 
import Header from "./Header";
import Student_tasks from "./components/Student_tasks";
import Teachers_tasks from "./components/Teachers_tasks";
import Teachers_task_info from "./components/Teachers_task_info";
import Permission from '../Permission'
import Teachers_games from './components/Teachers_games';
import Teachers_games_info from './components/Teachers_games_info';
import { Img } from '../../components/Elements';

export default function GamesResults({action}) {

    const { t } = useTranslation();
    let location = useLocation();
    let params = useParams();

    const { userData } = useContext(AppContext);
    const [userinfo, setuserinfo] = userData;

    const [filter, setfilter] = useState({}); 
    const [data, setdata] = useState({}); 
    const [loading, setloading] = useState(true); 

    async function loadData() {
        let r = await GET(`games/results?classes=${filter?.classes || ""}&text=${filter?.text || ""}`);
        setdata(r);
        setloading(false);
    }

    useEffect(() => {
        loadData();
    }, [filter?.classes, filter?.text]);

    if (loading) {
        return <Loader />
    }
    
    if (!data) {
        return false;
    }

    
    if (userinfo?.userlevel < 3) {
        return <Permission />
    } else {
            
        let perms = permissions(userinfo, params?.id, false, "games");
        if (!perms) {
            return <Permission />
        }
        
    }

    
    

    return (
        <>
            <div className='taskNewBody'>
                
                <Header />
                
                <div className='teacherTaskBox'>
                    
                    <div className='mainWidth shadow' style={{maxWidth:900}}>
        
                        <nav className='breadcrumbs'>
                            <Link to={`/`}>{t("home")}</Link>
                            <MdOutlineArrowLeft />
                            <Link>{t("games_results")}</Link>
                        
                        </nav>
        
                        <div className='mainMyTasksTitleBox'>
                            <h1 className='mainTitle'>{t("games_results")}</h1>
                           
                        </div>

                        <div className='tasksStatsBox ' >

                            <div >
                                <hr />
                                <p>
                                    <b>{data?.stats[0]}</b>
                                    <span>{t("tasks_stats_9")}</span>
                                </p>
                                <PiPencil />
                            </div>
      
                            <div>
                                <hr />
                                <p>
                                    <b>{data?.stats[1]}</b>
                                    <span>{t("tasks_stats_3")}</span>
                                </p>
                                <PiStudent />
                            </div>

                        </div>

        
        
                        <div className='filterBox'>
                            <div>
                
                            </div>
                            <form>
                                <input 
                                    className='searchInput' 
                                    type="search" 
                                    placeholder={`${t("search")}..`} 
                                    onChange={(d) => setfilter(p => ({
                                        ...p,
                                        text:d?.target?.value
                                    }))}
                                />
        
                                <select className='searchInput' style={{maxWidth:180}}
                                    onChange={(d) => setfilter(p => ({
                                        ...p,
                                        classes:d?.target?.value
                                    }))}
                                >
                                    <option value=''>- {t("classes")} -</option>
                                    {userinfo?.classes?.map((v, k) => {
                                        let cls = v?.split("-")[0];
                                        let grd = v?.split("-")[1];
                                        
                                        return (
                                            <option key={k} value={v}>{`${t("class")} ${global.Classes[cls]} (${global.Grades[grd]})`}</option>
                                        );
                                       
                                    })}
                                </select>
                            </form>
                        </div>
        
                        <div className='myTaskBody'>
                                    
                            <table className='table' style={{backgroundColor:"#fff"}}>
                                <thead>
                                    <tr>
                                        <td style={{width:80}}>{t("image")}</td>
                                        <td className='side'>{t("name")}</td>
                                        <td style={{width:120}}>{t("user")}</td>
                                        <td style={{width:100}}>{t("class")}</td>
                                        <td style={{width:80}}>{t("game_score")}</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data?.students?.map((v, k) => {

                                        return (
                                            <tr key={k}>
                                                <td ><Img src={v?.img} /></td>
                                                <td className='side'>{v?.name}</td>
                                                <td>{v?.user}</td>
                                                <td><span className='tag'><ClassToName  classes={v?.classes[0]}/></span></td>
                                                <td><span className='tag orange'>{v?.score}</span></td>
                                            </tr>

                                        );
                                    })}
                                </tbody>
                            </table>
        
                            {!data?.students?.length ? <div className='noData'>{t("error",  { returnObjects: true })[1]}</div>: false}
                        </div>
        
                        
        
                    </div>
        
        
                </div>
        
               
            </div>
        </>
    )
}
